import * as i0 from '@angular/core';
import * as i1 from './pagination.module';
import * as i2 from '@angular/common';
import * as i3 from './pager.component';
import * as i4 from './pagination.component';
export const PaginationModuleNgFactory:i0.NgModuleFactory<i1.PaginationModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.PagerComponent = (<any>(null as any));
var _decl0_12:i4.PaginationComponent = (<any>(null as any));
var _decl0_13:i2.AsyncPipe = (<any>(null as any));
var _decl0_14:i2.UpperCasePipe = (<any>(null as any));
var _decl0_15:i2.LowerCasePipe = (<any>(null as any));
var _decl0_16:i2.JsonPipe = (<any>(null as any));
var _decl0_17:i2.SlicePipe = (<any>(null as any));
var _decl0_18:i2.DecimalPipe = (<any>(null as any));
var _decl0_19:i2.PercentPipe = (<any>(null as any));
var _decl0_20:i2.TitleCasePipe = (<any>(null as any));
var _decl0_21:i2.CurrencyPipe = (<any>(null as any));
var _decl0_22:i2.DatePipe = (<any>(null as any));
var _decl0_23:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_24:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_25:i2.CommonModule = (<any>(null as any));
var _decl0_26:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_27:i0.ElementRef<any> = (<any>(null as any));
function _View_PagerComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_PagerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = i0.ɵinlineInterpolate(1,'',_decl0_11.pageBtnClass,'');
  currVal_0;
  const currVal_1:any = {'pull-right':_decl0_11.align,'float-right':_decl0_11.align};
  currVal_1;
  const currVal_2:any = _decl0_11.noPrevious();
  currVal_2;
  const currVal_3:any = _decl0_11.align;
  currVal_3;
  const currVal_4:any = _decl0_11.getText('previous');
  currVal_4;
  const currVal_5:any = i0.ɵinlineInterpolate(1,'',_decl0_11.pageBtnClass,'');
  currVal_5;
  const currVal_6:any = {'pull-right':_decl0_11.align,'float-right':_decl0_11.align};
  currVal_6;
  const currVal_7:any = _decl0_11.noNext();
  currVal_7;
  const currVal_8:any = _decl0_11.align;
  currVal_8;
  const currVal_9:any = _decl0_11.getText('next');
  currVal_9;
  const pd_10:any = ((<any>_decl0_11.selectPage((_decl0_11.page - 1),_any)) !== false);
  const pd_11:any = ((<any>_decl0_11.selectPage((_decl0_11.page + 1),_any)) !== false);
}
function _View_PaginationComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_PaginationComponent_2_1():void {
  if (_decl0_12.boundaryLinks) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_12.noPrevious() || _decl0_12.disabled);
    currVal_0;
    const currVal_1:any = _decl0_12.getText('first');
    currVal_1;
    const pd_2:any = ((<any>_decl0_12.selectPage(1,_any)) !== false);
  }
}
function _View_PaginationComponent_2_2():void {
  if (_decl0_12.directionLinks) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_12.noPrevious() || _decl0_12.disabled);
    currVal_0;
    const currVal_1:any = _decl0_12.getText('previous');
    currVal_1;
    const pd_2:any = ((<any>_decl0_12.selectPage((_decl0_12.page - 1),_any)) !== false);
  }
}
function _View_PaginationComponent_2_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.active;
  currVal_0;
  const currVal_1:any = (_decl0_12.disabled && !_any.active);
  currVal_1;
  const currVal_2:any = _any.text;
  currVal_2;
  const pd_3:any = ((<any>_decl0_12.selectPage(_any.number,_any)) !== false);
}
function _View_PaginationComponent_2_4():void {
  if (_decl0_12.directionLinks) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_12.noNext() || _decl0_12.disabled);
    currVal_0;
    const currVal_1:any = _decl0_12.getText('next');
    currVal_1;
    const pd_2:any = ((<any>_decl0_12.selectPage((_decl0_12.page + 1),_any)) !== false);
  }
}
function _View_PaginationComponent_2_5():void {
  if (_decl0_12.boundaryLinks) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_12.noNext() || _decl0_12.disabled);
    currVal_0;
    const currVal_1:any = _decl0_12.getText('last');
    currVal_1;
    const pd_2:any = ((<any>_decl0_12.selectPage(_decl0_12.totalPages,_any)) !== false);
  }
}
function _View_PaginationComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'pagination';
  currVal_0;
  const currVal_1:any = _decl0_12.classMap;
  currVal_1;
  const currVal_2:any = _decl0_12.boundaryLinks;
  currVal_2;
  const currVal_3:any = _decl0_12.directionLinks;
  currVal_3;
  const currVal_4:any = _decl0_12.pages;
  currVal_4;
  const currVal_5:any = _decl0_12.directionLinks;
  currVal_5;
  const currVal_6:any = _decl0_12.boundaryLinks;
  currVal_6;
}
